<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{ mode == MODE_APPROVE ? '入金締め承認画面' : '入金締め登録画面' }}</h1>

<!-- 検索条件コンポーネント -->
<form [formGroup]="searchCndtFormGroup" *ngIf="codeConversionMstMap?.size > 0 && cmpnyAreaList && systemDate" (ngSubmit)="search()">
    <app-sgke160d-search-condition [mode]=" mode"
        [codeConversionMstMap]="codeConversionMstMap" [cmpnyAreaList]="cmpnyAreaList" [cmpnyAreaInit]="cmpnyAreaInit"
        [businessDate]="systemDate" (onClickClearEmitter)="clear()"></app-sgke160d-search-condition>
</form>
<!-- 検索結果コンポーネント -->
<app-sgke160d-search-result *ngIf="searchresultList.length > 0" [mode]="mode" [searchresultList]="searchresultList"
    (onClickCancelEmitter)="cancel()" (onClickRegisterEmitter)="register()"
    (onClickApprovalEmitter)="approve()"></app-sgke160d-search-result>